import './index.less';



// WEBPACK FOOTER //
// ./components/config-provider/style/index.tsx